import { RefreshCw } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/components/ui';
import { useT } from '@/i18n';

/** A new deploy is ready: offer to reload instead of reloading on its own. */
export function UpdatePrompt() {
  const t = useT();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div role="status" className="fixed start-4 bottom-4 z-50 flex max-w-sm flex-wrap items-center gap-3 rounded-lg bg-ink px-4 py-3 text-base text-white shadow-pop print:hidden">
      <span className="flex-1">{t('pwa.update')}</span>
      <Button size="sm" variant="accent" icon={RefreshCw} onClick={() => void updateServiceWorker(true)}>
        {t('pwa.reload')}
      </Button>
      <Button size="sm" variant="ghost" className="text-white/80 hover:bg-white/10 hover:text-white" onClick={() => setNeedRefresh(false)}>
        {t('common.close')}
      </Button>
    </div>
  );
}
